import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderSlot as _renderSlot, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
var _hoisted_1 = {
  class: "d-flex flex-wrap align-items-center gap-2"
};
var _hoisted_2 = {
  class: "d-flex align-items-center"
};
var _hoisted_3 = ["href"];
var _hoisted_4 = {
  class: "p-0 mb-0 h4 fw-normal ms-2",
  "data-cy": "navigationHeader"
};
var _hoisted_5 = {
  class: "ms-auto"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_font_awesome_icon = _resolveComponent("font-awesome-icon");
  var _component_v_ifas_card = _resolveComponent("v-ifas-card");
  return _openBlock(), _createBlock(_component_v_ifas_card, {
    noHeader: ""
  }, {
    default: _withCtx(function () {
      return [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("a", {
        class: "btn ifas-btn-white ps-0 top-menu-back-button",
        href: $props.url
      }, [_createVNode(_component_font_awesome_icon, {
        icon: ['fas', 'arrow-left']
      })], 8 /* PROPS */, _hoisted_3), _createElementVNode("span", _hoisted_4, _toDisplayString($props.text), 1 /* TEXT */), _renderSlot(_ctx.$slots, "placeholder")]), _createElementVNode("div", _hoisted_5, [_renderSlot(_ctx.$slots, "buttons")])])];
    }),
    _: 3 /* FORWARDED */
  });
}